import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $processing, $done } from "services/activity/action";

export const MODULE = "Routing";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $manifest = ActionCreator.Async(MODULE, "Manifest", (id) => {
  return async (dispatch) => {
    dispatch($processing($manifest.OPERATION));

    return await Rest.GET(`${API_URL}/tms/routing/${id}/manifest`)
      .then((response) => {
        dispatch($manifest.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($manifest.OPERATION)));
  };
});
